import { getDateString, DATE_TIME_FORMAT } from 'lib/time';
import type { HistoryDataChange } from './types';

export function getFieldsChangesText(changes: HistoryDataChange[]): string {
    return `${changes.length > 0 ? changes.length : 'no'} ${changes.length === 1 ? 'field' : 'fields'} changed`;
}

export function getMetadataChanges(changes: HistoryDataChange[]): HistoryDataChange[] {
    return changes.filter((change) => change.path.startsWith('additional.metadata'));
}

export function createIsFieldChanged(changes: HistoryDataChange[]) {
    return function isFieldChanged(path: string | string[]): boolean {
        const paths = Array.isArray(path) ? path : [path];
        return paths.some((singlePath) => changes.some((change) => change.path === singlePath));
    };
}

export function formatEditedDate(updated: number): string {
    return updated && getDateString(updated, DATE_TIME_FORMAT);
}

export function formatAgeLimit(ageLimit: number | null): string {
    if (ageLimit || ageLimit === 0) {
        return ageLimit > 0 ? `${ageLimit} years` : 'All';
    }
    return undefined;
}
